<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row class="flex">
        <el-input
          size="small"
          placeholder="数据库名称"
          v-model.trim="query.dbName"
          clearable
          class="w-200px mr-10px"
        />
        <el-select
          size="small"
          clearable
          filterable
          placeholder="数据库类型"
          v-model.trim="query.dbType"
          class="w-200px mr-10px"
        >
          <el-option
            v-for="(item, index) in dbTypesList"
            :key="index"
            :label="item.item2"
            :value="item.item1"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="searchTableData()">{{ $t('search') }}</el-button>
        <el-button :disabled="!$hasAccess('create')" type="primary" @click="addConfigure()">{{
          $t('create')
        }}</el-button>
        <el-button size="small" @click="importFile">{{ $t('import') }}</el-button>
        <el-button size="small" @click="exportFile" :loading="exportLoading">{{
          $t('export')
        }}</el-button>
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        height="calc(100% - 106px)"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column show-overflow-tooltip label="数据库名称" prop="dbName"> </el-table-column>
        <el-table-column label="数据库类型" prop="dbTypeName" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column label="连接字符串" prop="connectionString" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          :label="$t('创建时间')"
          prop="creationTime"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column :label="$t('操作')" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              size="mini"
              @click="viewConfigure(scope.row)"
              >{{ $t('view') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('update')"
              @click="editConfigure(scope.row)"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('delete')"
              @click="deleteConfigure(scope.row.id)"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="getTableData"
        @size-change="searchTableData"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
      >
      </el-pagination>

      <!-- 新增和编辑 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="configureDialog"
        :close-on-click-modal="false"
        width="800px"
        v-dialogDrag
        class="addMapping"
      >
        <el-form :model="form" label-width="100px" :rules="rules" ref="form">
          <el-form-item label="数据库名称" prop="dbName">
            <el-input
              size="small"
              placeholder="数据库名称"
              v-model.trim="form.dbName"
              clearable
              class="w-full"
              :disabled="dialogTitle === '数据库配置详情'"
            />
          </el-form-item>
          <el-form-item label="数据库类型" prop="dbType">
            <el-select
              size="small"
              v-model="form.dbType"
              class="w-full"
              clearable
              filterable
              :disabled="dialogTitle === '数据库配置详情'"
              placeholder="数据库类型"
            >
              <el-option
                v-for="(item, index) in dbTypesList"
                :key="index"
                :label="item.item2"
                :value="item.item1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="连接字符串" prop="connectionString">
            <el-input
              size="small"
              placeholder="连接字符串"
              v-model.trim="form.connectionString"
              clearable
              class="w-full"
              :disabled="dialogTitle === '数据库配置详情'"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer tc" v-if="dialogTitle !== '数据库配置详情'">
          <el-button type="primary" @click="testConnection()" :loading="testLoading"
            >测试连接</el-button
          >
          <el-button type="primary" @click="save()" :loading="saveLoading">{{
            $t('save')
          }}</el-button>
          <el-button @click="configureDialog = false">{{ $t('cancel') }}</el-button>
        </div>
      </el-dialog>
    </el-card>

    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchTableData"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>

<script>
import FnMixins from '@/assets/js/fnMixins'
import { DbConnectionStringApi } from '@wiz-api/open-api-management'
import dayjs from 'dayjs'

const dbConnectionStringApi = new DbConnectionStringApi()
export default {
  name: 'databaseConfiguration',
  mixins: [FnMixins],
  data() {
    return {
      query: {
        dbName: null,
        dbType: null,
      },
      tableData: [],
      tableLoading: false,
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      dbTypesList: [],
      dialogTitle: '',
      configureDialog: false,
      form: {
        dbName: '',
        dbType: '',
        connectionString: '',
      },
      rules: {
        dbName: [{ required: true, message: '请输入数据库名称', trigger: 'blur' }],
        dbType: [{ required: true, message: '请选中数据库类型', trigger: 'blur' }],
        connectionString: [{ required: true, message: '请输入连接字符串', trigger: 'blur' }],
      },
      saveLoading: false,
      testLoading: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      exportLoading: false,
    }
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await dbConnectionStringApi.downloadTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '数据库配置导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await dbConnectionStringApi.callImport({
        file: formData.get('file'),
      })
      if (!err) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '数据库配置导入明细.xlsx',
          data: res,
        })
        this.searchTableData()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 导出
    async exportFile() {
      this.exportLoading = true
      const [err, res] = await dbConnectionStringApi.callExport({
        body: {
          dbName: this.query.dbName,
          dbType: this.query.dbType,
        },
      })
      this.exportLoading = false
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '数据库配置导出结果.xlsx',
          data: res,
        })
      }
    },
    // 从第一页开始搜索
    searchTableData() {
      this.pageNo = 1
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      const params = {
        dbName: this.query.dbName,
        dbType: this.query.dbType,
        sorting: '',
        skipCount: 1,
        maxResultCount: 15,
      }
      const [err, res] = await dbConnectionStringApi.getList(params)
      if (!err) {
        this.tableData = _.map(res.items, (item) => {
          if (item.creationTime) {
            item.creationTime = dayjs(new Date(item.creationTime)).format('YYYY-MM-DD HH:mm:ss')
          }
          return item
        })
        this.recordCount = res.totalCount
      }
    },
    // 获取数据库类型
    async getDbTypes() {
      const [err, res] = await dbConnectionStringApi.getDbTypes()
      if (!err) {
        this.dbTypesList = res
      }
    },
    // 新增
    addConfigure() {
      this.dialogTitle = '新增数据库配置'
      this.configureDialog = true
      this.form = this.$options.data().form
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    // 查看
    viewConfigure(row) {
      this.dialogTitle = '数据库配置详情'
      this.configureDialog = true
      this.form = _.cloneDeep(row)
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    // 编辑
    editConfigure(row) {
      this.dialogTitle = '编辑数据库配置'
      this.configureDialog = true
      this.form = _.cloneDeep(row)
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    // 删除
    deleteConfigure(id) {
      this.$confirm('是否确认删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await dbConnectionStringApi.deleteMany({ ids: [id] })
          if (!err) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
        .catch(() => {})
    },
    // 保存
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          if (this.form.id) {
            // 编辑
            const [err, res] = await dbConnectionStringApi.update(this.form.id, { body: this.form })
            if (!err) {
              this.$message.success('修改成功')
              this.saveLoading = false
              this.configureDialog = false
              this.searchTableData()
            }
          } else {
            // 新增
            const [err, res] = await dbConnectionStringApi.create({ body: this.form })
            if (!err) {
              this.$message.success('新增成功')
              this.saveLoading = false
              this.configureDialog = false
              this.searchTableData()
            }
          }
        }
      })
    },
    // 测试连接
    async testConnection() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const patams = {
            connectionString: this.form.connectionString,
            dbType: this.form.dbType,
          }
          const [err, res] = await dbConnectionStringApi.testConnect(patams)
          if (!err) {
            this.$message.success('测试连接成功')
          }
        }
      })
    },
  },
  async created() {
    await this.getDbTypes()
    this.searchTableData()
  },
}
</script>
